<template>
  <div>
    <section class="dialogsBox" v-show="auditIsShow">
      <div>
        <h3>
          财务批量审核
          <h4>{{ "已选中" + ids.length + "条费用" }}</h4>
        </h3>
        <a @click="rejectCancel" class="close">
          <a-icon type="close-circle" style="font-size: 30px; color: #333" />
        </a>
        <ul>
          <li>
            <label> <i>*</i>票据： </label>
            <a-radio-group v-model="is_ticket">
              <a-radio :value="2">票据齐全</a-radio>
              <a-radio :value="1">票据不全</a-radio>
            </a-radio-group>
          </li>
        </ul>
        <div>
          <a-button type="primary" @click="batchSubmit">确定</a-button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      flow_date: moment().format("YYYY-MM-DD"),
      ids: [],
      remark: "",
      auditIsShow: true,
      bank_flow_num: "",
      is_ticket: ""
    };
  },
  mounted() {
    if (this.batchFinanceIds != undefined) {
      this.getIds();
    }
  },
  props: {
    batchFinanceIds: Array
  },
  watch: {
    batchFinanceIds() {
      this.getIds();
    }
  },

  methods: {
    verify() {
      let fls = true;
      if (this.is_ticket == "") {
        fls = false;
        this.$message.warning("请选择票据信息");
        return fls;
      }
      return fls;
    },
    batchSubmit() {
      let fls = this.verify();
      if (fls) {
        this.auditIsShow = false;
        this.auditPassHttp();
        // let _this = this;
        // this.$confirm({
        //   title: "提示",
        //   cancelText: "取消",
        //   okText: "确认",
        //   content: "已再次确认进行批量操作",
        //   onOk() {
        //     _this.auditPassHttp();
        //   },
        //   onCancel() {
        //     _this.auditIsShow = true;
        //     _this.$emit("hideInDialogBatchFinanceAudit", false);
        //   }
        // });
      }
    },
    auditPassHttp() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "finance/financeCheckPassBatch";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        ids: JSON.stringify(this.ids),
        is_ticket: this.is_ticket
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.auditIsShow = true;
          this.$emit("hideInDialogBatchFinanceAudit", true);
          this.$message.success("批量操作成功");
        } else {
          this.$emit("hideInDialogBatchFinanceAudit", false);
          this.$message.error(res.data.message);
        }
      });
    },
    getIds() {
      this.ids = this.batchFinanceIds;
    },
    rejectCancel() {
      this.$emit("hideInDialogBatchFinanceAudit", false);
    }
  }
};
</script>
<style lang="less" scoped>
.dialogsBox > div h3 {
  h4 {
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #666;
    margin-top: 10px;
  }
}
</style>
